import { render } from "./ExpandIcon.vue?vue&type=template&id=23e7e7b4&ts=true"
import script from "./ExpandIcon.vue?vue&type=script&lang=ts"
export * from "./ExpandIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__